<template>
  <div class="quantity-selection field">
    <div class="quantity-selection--title">
      <label>{{label}}</label>
    </div>
    <div class="quantity-selection--content">
      <quantity-selection-item @change="change" :value="newValue" :item="value" v-for="value in collection" :key="value.value">
      </quantity-selection-item>
    </div>
  </div>
</template>
<script>
import QuantitySelectionItem from './QuantitySelectionItem'
export default {
  components: {QuantitySelectionItem},
  props: {
    label: String,
    classes: Array,
    name: String,
    value: {},
    type: {
      type: String,
      default: 'text'
    },
    placeholder: String,
    required: {
      type: Boolean,
      default: false
    },
    collection: {},
    params: {
      type: Object,
      default: () => {}
    },
    errors: {
      type: Array,
      default: () => []
    },
    model: String
  },
  data () {
    return {
      newValue: '',
      error: undefined
    }
  },
  mounted () {
    this.newValue = this.value
  },
  methods: {
    change(name,value){
      this.newValue[name] = value
    }
  },
  computed: {
    newLabel(){
      if(this.label){
        return this.label
      }else{
        return 'models.' + this.model + '.' + this.name
      }
    },
    newCollection(){
      if(this.collection){
        let newCollection = []
        this.collection.forEach( (item) => {

          newCollection.push({value: item.value, name: item.name})

        })
        if(this.type == "radio"){
          if(_.get(this.params, 'empty_choice')){
            newCollection.push({value: "", name: "-"})
          }
        }
        return newCollection
      }
    }
  },
  watch: {
    errors (errors){
      this.error = undefined
      this.errors.forEach((error) => {
        if(error.field_name == this.name){
          this.error = this.$t('errors.' + error.code)
        }
      })
    },
    value (val) {
      if (val !== this.newValue) {
        this.newValue = val
      }
    },
    newValue (val) {
      this.$emit('input', val)
    }
  }
}
</script>
<style lang="scss">
.quantity-selection--title{
  margin-bottom: 8px;
}
.quantity-selection--content{
  display: flex;
  flex-wrap: wrap;
}
</style>



// WEBPACK FOOTER //
// QuantitySelection.vue?91ad3066